import statusConst from '@/consts/status.const.js';
import pixAxios from '@/axios/pixAxios.js';

const comparableAuditLogModule = {
  namespaced: true,
  state: {
    comparableAuditLog: null,
    status: statusConst.PENDING,
  },
  actions: {
    async loadComparableAuditLog({ state, commit, dispatch }, { comparableCode }) {
      commit('setStatus', statusConst.LOADING);
      dispatch('loadingOverlayModule/setIsLoading', true, { root: true });

      const { data } = await pixAxios.get(`api/Comparables/GetComparableAudit?comparableCode=${comparableCode}`);

      dispatch('loadingOverlayModule/setIsLoading', false, { root: true });
      commit('setAuditLog', data);
      commit('setStatus', statusConst.SUCCESS);
    },

    closeModal({ state, commit }) {
      commit('setAuditLog', null);
    },

    setStatus({ commit }, payload) {
      commit('setStatus', payload);
    },
  },

  mutations: {
    setAuditLog(state, auditLog) {
      state.comparableAuditLog = auditLog;
    },

    setStatus(state, payload) {
      state.status = payload;
    },
  },

  getters: {
    getAuditLog(state) {
      return state.comparableAuditLog;
    },

    getStatus(state) {
      return state.status;
    },

    getSortedAuditLog(state) {
      return state.comparableAuditLog.sort(({ TimeStamp: a }, { TimeStamp: b }) => a >= b ? -1 : 1);
    },

  },
};
export default comparableAuditLogModule;
